// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const mobileMenu = document.querySelector('.mobile-menu');
  
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function() {
      mobileMenu.classList.toggle('active');
      const isOpen = mobileMenu.classList.contains('active');
      menuBtn.setAttribute('aria-expanded', isOpen);
    });
  }

  // FAQ Accordion
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function(item) {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', function() {
        const isActive = item.classList.contains('active');
        // Close all
        faqItems.forEach(function(i) { i.classList.remove('active'); });
        // Open clicked if it was closed
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });

  // Thumbnail gallery
  const thumbnails = document.querySelectorAll('.thumbnail-btn');
  const mainImage = document.querySelector('.main-image');
  
  thumbnails.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbnails.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      
      const imgSrc = thumb.getAttribute('data-image');
      if (imgSrc && mainImage) {
        const img = mainImage.querySelector('img');
        const placeholder = mainImage.querySelector('.placeholder');
        if (img) {
          img.src = imgSrc;
        } else if (placeholder && imgSrc) {
          placeholder.innerHTML = '<img src="' + imgSrc + '" alt="Hemodiyaliz Kitabı">';
        }
      }
    });
  });

  // Quantity controls
  const quantityGroups = document.querySelectorAll('[data-quantity-sync]');
  quantityGroups.forEach(function(group) {
    const input = group.querySelector('[data-quantity-input]');
    const minus = group.querySelector('[data-quantity-minus]');
    const plus = group.querySelector('[data-quantity-plus]');
    const targets = [];
    let next = group.nextElementSibling;

    while (next && !next.hasAttribute('data-quantity-sync') && !next.classList.contains('trust-badges')) {
      targets.push.apply(targets, Array.prototype.slice.call(next.querySelectorAll('[data-quantity-target]')));
      next = next.nextElementSibling;
    }

    function cleanValue(value) {
      const parsed = parseInt(value, 10);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    }

    function sync(value) {
      const quantity = cleanValue(value);
      input.value = quantity;
      targets.forEach(function(target) {
        target.value = quantity;
      });
    }

    if (input) {
      sync(input.value);
      input.addEventListener('input', function() { sync(input.value); });
      input.addEventListener('change', function() { sync(input.value); });
    }

    if (minus) {
      minus.addEventListener('click', function() {
        sync(cleanValue(input.value) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function() {
        sync(cleanValue(input.value) + 1);
      });
    }
  });
});
